import EmployerDetails from "./employerDetails";
export default EmployerDetails;